import { useEffect } from "react";
import { useWorkspaceStore } from "@/store/workspace-store";
import { useAuthStore } from "@/store/auth-store";

export function useWorkspaceInit() {
  const { initializeWorkspaces } = useWorkspaceStore();
  const user = useAuthStore((state) => state.user);

  useEffect(() => {
    if (user) {
      initializeWorkspaces().catch(console.error);
    }
  }, [initializeWorkspaces, user]);
}
